fragment PeepSendToDestinations on Peep {
    id
    type
    name
    avatarUrl
    initials
    htmlUrl
    isDeleted
    sendToDestinations {
        localUrl
        name
    }
    externalResources {
        externalService
        externalResourceType
        externalId
    }
    ... on Contact {
        emailAddresses {
            primary {
                isPrimary
                value {
                    address
                    display
                    formatted
                }
            }
        }
    }
}
